export const LAUNCHER_BYLINE_MAX_LENGTH = 90;

export type LauncherBylineSettings = {
  launcherByline?: string;
  launcherBylineByLocale?: Partial<Record<"en" | "es", string>>;
};

const defaults = { en: "Your website assistant", es: "Tu asistente en la web" };

export function normalizeLauncherBylineSettings(value: unknown): LauncherBylineSettings | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const source = value as Record<string, unknown>;
  const out: LauncherBylineSettings = {};
  const validText = (text: unknown): text is string =>
    typeof text === "string" && text.trim().length <= LAUNCHER_BYLINE_MAX_LENGTH && !/[\u0000-\u001f\u007f<>]/.test(text);

  if (source.launcherByline !== undefined) {
    if (!validText(source.launcherByline)) return null;
    out.launcherByline = source.launcherByline.trim();
  }
  if (source.launcherBylineByLocale !== undefined) {
    const locales = source.launcherBylineByLocale;
    if (!locales || typeof locales !== "object" || Array.isArray(locales)) return null;
    out.launcherBylineByLocale = {};
    for (const [locale, text] of Object.entries(locales)) {
      if ((locale !== "en" && locale !== "es") || !validText(text)) return null;
      out.launcherBylineByLocale[locale] = text.trim();
    }
  }
  return out;
}

export function resolveLauncherByline(value: unknown, locale: string): string {
  const language = locale.toLowerCase().startsWith("es") ? "es" : "en";
  const settings = normalizeLauncherBylineSettings(value) ?? {};
  // Missing legacy settings keep the default; an explicitly empty value hides the line.
  return settings.launcherBylineByLocale?.[language] ?? settings.launcherByline ?? defaults[language];
}
